(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lia-offers-popover"] && !Shopify.designMode) return;
  try {
    (function() {
  if (window.__liaOffersRailListenerInstalled) return;
  window.__liaOffersRailListenerInstalled = true;

  function getRoot() {
    return document.querySelector('[data-lia-offers-rail]');
  }
  function setOpen(root, open, focusButton) {
    if (!root) return;
    var button = root.querySelector('[data-lia-offers-toggle]');
    var panel = root.querySelector('[data-lia-offers-panel]');
    if (!button || !panel) return;
    if (!open && focusButton) button.focus();
    root.classList.toggle('is-open', open);
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    button.setAttribute('aria-label', open ? 'إغلاق عروض LIA' : 'افتح عروض LIA');
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open) panel.removeAttribute('inert');
    else panel.setAttribute('inert', '');
  }

  document.addEventListener('click', function(event) {
    var root = getRoot();
    if (!root) return;
    if (event.target.closest('[data-lia-offers-toggle]') && root.contains(event.target)) {
      setOpen(root, !root.classList.contains('is-open'), false);
      return;
    }
    if (event.target.closest('[data-lia-offers-close]') && root.contains(event.target)) {
      setOpen(root, false, true);
      return;
    }
    if (!root.contains(event.target) && root.classList.contains('is-open')) {
      setOpen(root, false, false);
    }
  });

  /* Prevent an expanded offers panel from popping back after the cart closes. */
  document.addEventListener('toggle', function(event) {
    if (event.target.matches && event.target.matches('.cart-drawer-container') && event.target.open) {
      var rail = getRoot();
      if (rail) setOpen(rail, false, false);
    }
  }, true);

  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Escape') return;
    var root = getRoot();
    if (!root || !root.classList.contains('is-open')) return;
    setOpen(root, false, true);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
